import React from "react";
import { Box, Center, Flex, Heading, Icon, SimpleGrid, Skeleton, Text } from "@chakra-ui/react";
import { FiCalendar, FiFileText, FiUserCheck, FiUsers } from "react-icons/fi";
import { useQuery } from "react-query";
import { fetchStatsApi } from "../../../api/admin";

const StatCard = ({ title, value, details, icon, color }) => (
  <Box borderWidth="1px" borderRadius="xl" p="5">
    <Flex justify="space-between" align="flex-start" gap="4">
      <Box><Text color="gray.500" fontSize="sm" fontWeight="700">{title}</Text><Text mt="2" fontSize="3xl" fontWeight="800">{value || 0}</Text><Text mt="2" color="gray.500" fontSize="sm">{details}</Text></Box>
      <Center boxSize="11" bg={`${color}.50`} color={`${color}.600`} borderRadius="xl"><Icon as={icon} boxSize="5" /></Center>
    </Flex>
  </Box>
);

const Overview = () => {
  const query = useQuery(["adminOverviewStats"], fetchStatsApi);
  const stats = query.data?.data;
  const scopeLabel = stats?.scope?.kind === "unit" ? stats.scope.unit : "the hospital system";
  if (query.isLoading) return <SimpleGrid columns={{ base: 1, md: 2 }} gap="4">{[1, 2, 3, 4].map((item) => <Skeleton key={item} h="145px" borderRadius="xl" />)}</SimpleGrid>;
  if (query.isError) return <Center minH="220px"><Text color="red.500">Unable to load administration summary.</Text></Center>;
  const cards = [
    { title: "Patients", value: stats?.patients?.total, details: `${stats?.patients?.approved || 0} approved · ${stats?.patients?.pending || 0} awaiting approval`, icon: FiUsers, color: "blue" },
    { title: "Workers", value: stats?.workers?.total, details: `${stats?.workers?.active || 0} active · ${stats?.workers?.pending || 0} pending`, icon: FiUserCheck, color: "green" },
    { title: "Attendances", value: stats?.appointments?.total, details: `${stats?.appointments?.open || 0} open · ${stats?.appointments?.today || 0} started today`, icon: FiCalendar, color: "orange" },
    { title: "Request forms", value: stats?.requestForms?.total, details: `${stats?.requestForms?.active || 0} active · ${stats?.requestForms?.archived || 0} archived`, icon: FiFileText, color: "purple" },
  ];
  return (
    <Box>
      <Heading size="sm">System overview</Heading>
      <Text mt="1" mb="5" color="gray.500" fontSize="sm">Current operational totals across {scopeLabel}.</Text>
      <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} gap="4">{cards.map((card) => <StatCard key={card.title} {...card} />)}</SimpleGrid>
    </Box>
  );
};

export default Overview;
